<template>
  <v-dialog v-model="dialogVisible" max-width="400px">
    <v-card>
      <v-card-title class="text-h5">{{ message }}</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialogVisible = false">Zrušit</v-btn>
        <v-btn color="blue darken-1" text @click="confirmAction">Potvrdit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",

  props: {
    message: String,
    action: Function,
  },

  data: () => ({
    dialogVisible: false,
  }),

  watch: {
    action: function (action) {
      if (action) {
        this.dialogVisible = true;
      }
    }
  },

  methods: {
    confirmAction() {
      this.action();
      this.dialogVisible = false;
    }
  },
}
</script>

<style scoped>

</style>